module.exports = __webpack_public_path__ + "img/iso.f49072e1.svg";